module.exports = __webpack_public_path__ + "img/arbre_3_ombre.ce2cdb01.png";